import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {UserAvailability, DAYS_OF_WEEK} from '@/features/users-availability/types'
import {FC} from 'react'
import {DayRow} from './UserAvailabilityAtoms'

interface UserAvailabilityViewProps {
    availability: UserAvailability
}

export const UserAvailabilityView: FC<UserAvailabilityViewProps> = ({availability}) => {
    return (
        <Grid columns={2} gap={1} fullWidth>
            {DAYS_OF_WEEK.map((day, index) => (
                <DayRow
                    key={day}
                    day={day}
                    dayAvailability={availability[day]}
                    isLast={index === DAYS_OF_WEEK.length - 1}
                />
            ))}
        </Grid>
    )
}
